export default __webpack_public_path__ + "static/media/BrainBreak cards57.24455a45.png";